import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import EventEmitter from './EventEmitter.js'
import Experience from '../Experience.js'

export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        this.sources = sources

        this.experience = new Experience()

        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0

        this.setLoaders()
        this.startLoading()
    }

    setLoaders()
    {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.DRACOLoader = new DRACOLoader()
        this.loaders.DRACOLoader.setDecoderPath('/draco/')
        this.loaders.gltfLoader.setDRACOLoader(this.loaders.DRACOLoader)
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
        this.loaders.audioLoader = new THREE.AudioLoader()
    }

    startLoading()
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    },
                    (loading) => {
                        // console.log(loading,  source.name)
                    },
                    (error) => {
                        console.log(error, source.name)
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    },
                    (loading) => {
                        // console.log(loading, source.name)
                    },
                    (error) => {
                        console.log(error, source.name)
                    }
                )
            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    },
                    (loading) => {
                        // console.log(loading)
                    },
                    (error) => {
                        console.log(error, source.name)
                    }
                )
            }
        }
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file

        this.loaded++

        this.experience.UI.homepage.btn.style.background = `linear-gradient(to left, lightgray 50%, #c03d00 50%) ${100 - ((this.loaded)/this.toLoad) * 100}%`


        if(this.loaded === this.toLoad)
        {
            this.trigger('ready')
            this.experience.UI.homepage.btn.classList.add('active')
            this.experience.UI.homepage.btn.innerHTML = "Commencer l'expérience"
        }
    }
}